import { render, staticRenderFns } from "./wf-checkbox-list-with-other-display.vue?vue&type=template&id=a59c9a70&scoped=true&"
import script from "./wf-checkbox-list-with-other-display.vue?vue&type=script&lang=ts&"
export * from "./wf-checkbox-list-with-other-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-checkbox-list-with-other-display.vue?vue&type=style&index=0&id=a59c9a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59c9a70",
  null
  
)

export default component.exports